import { callFunctionRaw } from "@/lib/callFunction";

async function invoke(action, payload = {}) {
  const data = await callFunctionRaw("paystack-pharmacy-settlement", { action, ...payload }, {
    timeoutMs: 30000,
    preferFreshSession: true,
  });
  if (data?.error) throw new Error(String(data.error));
  return data || {};
}

export const getPharmacySettlementStatus = () => invoke("status");
export const listPharmacySettlementBanks = () => invoke("banks");
export const connectPharmacySettlementAccount = (details) => invoke("connect", details);
